<header id="app-header">
    <nav class="app-nav">
        <div class="nav-wrapper">
            <div>
                <a title="Start">
                    <img src="assets/images/logo-krematorium-am-limes.png" class="rtk-icon" alt="RTK Logo">
                </a>
            </div>
            <div><!-- Spacer --></div>
        </div>
    </nav>
</header>

<main id="main" class="container">
    <div class="row main-content-row">
        <div class="col s12">
            <!-- Loading Spinner -->
            <div class="loading-container" *ngIf="isLoading">
                <div class="juvo-spinner">
                    <div class="preloader-wrapper big active">
                        <div class="spinner-layer spinner-green-only">
                            <div class="circle-clipper left">
                                <div class="circle"></div>
                            </div>
                            <div class="gap-patch">
                                <div class="circle"></div>
                            </div>
                            <div class="circle-clipper">
                                <div class="circle"></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Document Content -->
            <div class="document-content" *ngIf="!isLoading">
                <div class="document-header" *ngIf="files.length > 0">
                    <div class="header-content">
                        <h4 class="document-title">
                            <i class="material-icons">folder</i>
                            <span *ngIf="entryId != 'all'">Dokumente zum Sterbefall #{{entryId}}</span>
                            <span *ngIf="entryId == 'all'">Alle Dokumente</span>
                        </h4>
                        
                        <div class="action-buttons">
                            <button class="redesign action" (click)="navigateBack()">
                                <i class="material-icons">arrow_back</i>
                                Zurück
                            </button>

                            <button class="redesign action" (click)="download()">
                                <i class="material-icons">download</i>
                                Alle herunterladen ({{selectedFiles.length}})
                            </button>

                            <button class="redesign action" *ngIf="entryId == 'all'" (click)="filterButtonClicked()">
                                <i class="material-icons">filter_list</i>
                                Filter
                            </button>
                        </div>
                    </div>
                </div>

                <!-- Document List -->
                <div class="document-list" *ngIf="files.length > 0">
                    <ul class="collection">
                        <li class="collection-item" *ngFor="let file of files; let index = index">
                            <div class="document-item-content">
                                <div class="document-icon" (click)="openPdfAtIndex(index)">
                                    <i class="material-icons">picture_as_pdf</i>
                                </div>

                                <div class="document-details">
                                    <div class="document-info">
                                        <span class="title">{{file.beleg_typ}}</span>
                                        <span class="document-number">{{file.beleg_nr}}</span>
                                    </div>
                                    <div class="document-date">
                                        <i class="material-icons">event</i>
                                        <span>{{file._erstellt | longReadableDate}}</span>
                                    </div>
                                </div>

                                <div class="document-actions">
                                    <button class="action-button" (click)="openPdfAtIndex(index)" title="Vorschau">
                                        <i class="material-icons">search</i>
                                    </button>
                                    <button class="action-button" (click)="downloadSingleFileAtIndex(index)" title="Herunterladen">
                                        <i class="material-icons">file_download</i>
                                    </button>
                                </div>
                            </div>
                        </li>
                    </ul>
                </div>

                <!-- Empty State -->
                <div class="empty-state" *ngIf="files.length == 0">
                    <i class="material-icons">folder_off</i>
                    <h5 *ngIf="entryId != 'all'">Es stehen keine Dokumente zum Sterbefall #{{entryId}} bereit</h5>
                    <h5 *ngIf="entryId == 'all'">Es stehen keine Dokumente bereit</h5>
                </div>

                <!-- Load More Button -->
                <div class="load-more-container" *ngIf="entryId == 'all' && files.length > 0">
                    <button class="redesign action load-more" (click)="loadMoreButtonClicked()" *ngIf="!isLoading">
                        <i class="material-icons">expand_more</i>
                        Mehr laden
                    </button>
                </div>
            </div>
        </div>
    </div>
</main>

<!-- PDF Preview Modal -->
<div id="filedetailmodal" class="modal">
    <div class="modal-content">
        <div class="modal-header">
            <h4>{{selectedFile?.beleg_typ}}</h4>
            <button class="modal-close" (click)="closeModal()">
                <i class="material-icons">close</i>
            </button>
        </div>
        <div class="modal-body" *ngIf="selectedFile && selectedFile.dok_base64">
            <object [data]="selectedFile.dok_base64 | safeBaseUrl: 'application/pdf'" class="pdf-detail-object"></object>
        </div>
    </div>
</div>

<div id="filtermodal" class="modal" style="min-height: inherit !important; top: 15vh !important;"
    *ngIf="entryId == 'all'">
    <div class="modal-content">
        <a class="btn-flat right" onclick="closeModalWithID('filtermodal')"><i
                class="material-icons large">close</i></a>
        <h4 class="action-color">Filter</h4>
        <div class="row" *ngIf="filterValues.length > 0">
            <div class="col s12">
                <p>Aktive Filter:</p>
                <div class="chip" *ngFor="let filterValue of filterValues"
                    style="margin-right: 8px; margin-bottom: 8px;">
                    {{filterValue.filterLabel()}}
                    <i class="material-icons" (click)="deleteFilterValue(filterValue)">close</i>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="input-field col s11">
                <input id="inputFilterStart" type="text" placeholder="tt.mm.yyyy" class="inputFilterStart"
                    maxlength="10" (keyup.enter)="addFilterValue('inputFilterStart')">
                <label id="inputFilterStartLabel" for="inputFilterStart"
                    class="inputFilterStartLabel active">Von</label>
            </div>
            <div class="input-field col s1">
                <i class="material-icons redesign action cursor-pointer" style="margin-top: 10px;"
                    (click)="addFilterValue('inputFilterStart')">add</i>
            </div>
        </div>
        <div class="row">
            <div class="input-field col s11">
                <input id="inputFilterEnd" type="text" placeholder="tt.mm.yyyy" class="inputFilterEnd" maxlength="10"
                    (keyup.enter)="addFilterValue('inputFilterEnd')">
                <label id="inputFilterEndLabel" for="inputFilterEnd" class="inputFilterEndLabel active">Bis</label>
            </div>
            <div class="input-field col s1">
                <i class="material-icons redesign action cursor-pointer" style="margin-top: 10px;"
                    (click)="addFilterValue('inputFilterEnd')">add</i>
            </div>
        </div>

        <div class="row">
            <div class="input-field col s11">
                <input id="inputFilterInvoiceNumber" type="text" class="inputFilterInvoiceNumber"
                    (keyup.enter)="addFilterValue('inputFilterInvoiceNumber')">
                <label id="inputFilterInvoiceNumberLabel" for="inputFilterInvoiceNumber"
                    class="inputFilterInvoiceNumberLabel">Belegenummer</label>
            </div>
            <div class="input-field col s1">
                <i class="material-icons redesign action cursor-pointer" style="margin-top: 10px;"
                    (click)="addFilterValue('inputFilterInvoiceNumber')">add</i>
            </div>
        </div>

        <div class="section"></div>
        <div class="row">
            <div class="input-field col s12">
                <span class="left"><i class="material-icons redesign action"
                        (click)="deleteAllFilters()">delete</i></span>
                <a class="waves-effect waves-light btn white-text right" style="background-color: #991F26;"
                    (click)="useFilterButtonClicked()">Filter anwenden</a>
            </div>
        </div>
    </div>
</div>